// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"822cec23","239":"cafd29b4","453":"51b20bab","732":"7083df76"}[chunkId] + ".chunk.js";
};